import * as React from 'react';
import { useMemo } from 'react';
import styled from 'styled-components';

import { ImageCategory } from '@tractable/estimating-local-constants';

import { Box } from '../../shared/Box';
import { ImageDownloader } from '../../shared/ImageDownloader';
import { ImageViewer } from '../../shared/ImageViewer/ImageViewer';
import { sortImages } from '../../shared/sortImages';
import { useGetCoaSessionQuery } from './DigitalJoruney/generated/DigitalJourneyView.generated';

interface Props {
	claim: any;
	config: any;
}
const ImagesWrapper = styled(Box)`
	position: sticky;
	top: 70px;
`;
export const Images: React.FC<Props> = ({ claim: { id, images }, config }) => {
	const allImages = [...images];

	const { data: coaSessionData } = useGetCoaSessionQuery({ variables: { id } });

	const mappedImages = useMemo(() => {
		if (config?.ui?.showDigitalJourneyData) {
			if (coaSessionData && coaSessionData.coaSession) {
				// Additional photos are only synced to claim.images when vehicle/damage photos are also present
				// (see startClassificationEvent.ts). Fall back to coaSession.additionalPhotos for claims
				// where only additional document photos were uploaded.
				const hasAdditionalInClaim = images.some((img) => img.imageCategory === ImageCategory.ADDITIONAL);
				if (!hasAdditionalInClaim) {
					const sessionAdditionalPhotos = coaSessionData.coaSession.additionalPhotos || [];
					allImages.push(...sessionAdditionalPhotos);
				}

				if (coaSessionData.coaSession.digitalJourney) {
					const digitalJourney = coaSessionData.coaSession.digitalJourney;
					const digitalJourneyImages = [
						...(digitalJourney.caiPhotos || []),
						...(digitalJourney.authoritiesPhotos || []),
						...(digitalJourney.hospitalReportPhotos || []),
					];
					allImages.push(...digitalJourneyImages);
				}
			}
		}

		return sortImages(allImages).map((i) => ({
			original: i.path,
			thumbnail: i.path,
		}));
	}, [coaSessionData, config]);

	return (
		<ImagesWrapper orientation="vertical">
			<Box justifyContent="flex-end">
				<ImageDownloader id={id} />
			</Box>
			<ImageViewer images={mappedImages} />
		</ImagesWrapper>
	);
};
